module.exports = __webpack_public_path__ + "static/media/file-mov.7ec370d4.svg";